/**
 * The NOW chip (1.O-1 deliverable 16), mounted once by the frame and portaled into the header's
 * end region through `ShellHeaderItems`. This module stays light: with the `chrono` flag off it
 * renders nothing and asks nothing, and the control (the calendar engine, the When input) loads
 * only when the flag is on.
 */
import { flagsFromMe } from '@codex/contracts';
import { lazy, Suspense } from 'react';
import { ShellHeaderItems } from '../shell/header-slot.js';
import { useShellSession } from '../shell/session.js';

const NowControl = lazy(() =>
  import('./now-control.js').then((module) => ({ default: module.NowControl })),
);

export function NowChip() {
  const me = useShellSession();
  if (me === null || flagsFromMe(me).chrono !== true) return null;
  return (
    <ShellHeaderItems place="now">
      <Suspense fallback={null}>
        <NowControl />
      </Suspense>
    </ShellHeaderItems>
  );
}
